import {
  Component,
  Input,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexYAxis,
  ApexLegend,
  ApexXAxis,
  ApexTooltip,
  ApexTheme,
  ApexGrid,
  ApexPlotOptions,
  ApexFill,
  ApexAnnotations,
} from 'ng-apexcharts';

import { DailyAmount, DateFilters } from '../../interface/data.interface';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: any;
  theme: ApexTheme;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
  colors: string[];
  markers: any;
  grid: ApexGrid;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;

  annotations: ApexAnnotations;
  labels: string[];
};

import * as moment from 'moment';
import { first } from 'rxjs';

@Component({
  selector: 'app-factoring-monthly-amount',
  templateUrl: './factoring-monthly-amount.component.html',
  styleUrls: ['./factoring-monthly-amount.component.scss'],
})
export class FactoringMonthlyAmountComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @Input() recieveFilterDate: DateFilters;
  @Input() recieveFilterName: string;
  @Input() dailyAmount: DailyAmount;
  public dateValue: any;
  public booleanFlag: boolean = false;

  public gredientChartOptions: Partial<ChartOptions> | any;
  public activeOptionButton = '1m';

  public todosLosMesesConDatos: DailyAmount[] = [];
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });



  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    let boardDeals: Array<DailyAmount> = changes['dailyAmount'].currentValue;
    this.todosLosMesesConDatos = boardDeals;    
    this.generateChart();
    if (changes['dailyAmount'].currentValue !== undefined) {
      this.booleanFlag = true;
      this.todosLosMesesConDatos = boardDeals;
      this.generateChart();
    }
  }


  generateChart() {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    this.gredientChartOptions = {
      series: [
        {
          name: 'Montos',
          data: Array.isArray(this.todosLosMesesConDatos)
            ? this.todosLosMesesConDatos.map((e) => e.amount)
            : [],
        },
      ],
      chart: {
        zoom: {
          enabled: true,
        },
        height: 350,
        type: 'bar',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        foreColor: '#adb0bb',

        dropShadow: {
          position: 'top',
        },
        toolbar: {
          show: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: '60%',
        },
      },
      stroke: {
        curve: 'smooth',
      },
      hover: {
        filter: {
          type: 'lighten',
          value: 0.15,
        },
      },
      xaxis: {
        type: 'datetime',
        categories: this.todosLosMesesConDatos.map((e) => e.date),
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'horizontal',
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100],
        },
      },
      markers: {
        size: 4,
        opacity: 0.9,
        colors: ['#5D87FF'],
        strokeColor: '#fff',
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      yaxis: {
        min: 0,
        max: 10000000000,
        labels: {
          formatter: function (value: any) {
            var str = value.toString().split('.');
            str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return '$ ' + str.join('.');
          },
        },
      },

      tooltip: {
        theme: 'dark',
      },
      grid: {
        show: false,
      },
    };
  }

  generateDateRange(startDate: Date, endDate: Date): string[] {
    const dateRange: string[] = [];
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      dateRange.push(currentDate.toISOString());
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateRange;
  }
}
